const styles = {
  '&::-webkit-scrollbar': {
    backgroundColor: 'tranparent',
    width: '16px',
  },
  '&::-webkit-scrollbar-track': {
    backgroundColor: 'tranparent',
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: '#ddd',
    borderRadius: '16px',
    border: '4px solid #fff',
  },
  '&::-webkit-scrollbar-button': {
    display: 'none',
  },
};

export default styles;
